import { PieChart, Pie, Cell, ResponsiveContainer, Tooltip } from "recharts";
import PropTypes from "prop-types";

export function RadialRing({ data, colors, centerLabel, onSegmentClick }) {
  return (
    <ResponsiveContainer width="100%" height={240}>
      <PieChart>
        <Pie
          data={data}
          cx="50%"
          cy="50%"
          innerRadius="72%"
          outerRadius="92%"
          paddingAngle={3}
          dataKey="value"
          stroke="none"
          animationDuration={900}
          animationEasing="ease-out"
          onClick={(_, idx) => onSegmentClick?.(data[idx])}
          style={onSegmentClick ? { cursor: "pointer" } : undefined}
        >
          {data.map((_, i) => (
            <Cell key={i} fill={colors?.[i] || "#60a5fa"} />
          ))}
        </Pie>
        <Tooltip
          contentStyle={{ borderRadius: 10, fontSize: 13 }}
          wrapperClassName="fleet-chart-tooltip"
          formatter={(v, name) => [`${v} chargers`, name]}
        />
        {centerLabel && (
          <text
            x="50%"
            y="50%"
            textAnchor="middle"
            dominantBaseline="middle"
            className="fleet-chart-center-label"
            style={{ fontSize: "0.8rem", fontWeight: 700 }}
          >
            {centerLabel}
          </text>
        )}
      </PieChart>
    </ResponsiveContainer>
  );
}

RadialRing.propTypes = {
  data: PropTypes.arrayOf(PropTypes.shape({ name: PropTypes.string, value: PropTypes.number })).isRequired,
  colors: PropTypes.array,
  centerLabel: PropTypes.string,
  onSegmentClick: PropTypes.func,
};

export default RadialRing;
